import * as React from 'react';
import { IconButton } from '@mui/material';
import { Icon } from '../../lib/icons';

export const ZoomOutButton: React.FC<{ enabled: boolean; onClick?: () => void }> = (props) => (
    <IconButton  data-testid={'zoom-out-button'} disabled={!props.enabled} onClick={props.onClick} size="large">
        <Icon.ZoomOut />
    </IconButton>
);
